<template>
  <form class="c-form" @submit="formSubmit">
    <slot/>
  </form>
</template>

<script>
export default {
  props: {
    preventSubmit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formSubmit (e) {
      if (this.preventSubmit)
      {
        e.preventDefault();
      }
    }
  }
};
</script>
